module.exports = __webpack_public_path__ + "img/21.ef39444f.svg";